<template>
  <div>
    <div class="vs-row">
      <vs-col vs-lg="6" vs-xs="12">
        <div class="con-vs-card cardx overflow-hidden">
          <header class="vs-card--header">
            <div>
              <h6 class="font-medium">Scatter</h6>
            </div>
          </header>
          <div class="vs-card--content p-0">
             <chartjs-scatter-chart
                  :height="250"
                  :data="ChartOptions.scatterchart.data"
                  :options="ChartOptions.scatterchart.options"
                ></chartjs-scatter-chart>
             </div>
        </div>
      </vs-col>
       <vs-col vs-lg="6" vs-xs="12">
        <div class="con-vs-card cardx overflow-hidden">
          <header class="vs-card--header">
            <div>
              <h6 class="font-medium">Doughnut</h6>
            </div>
          </header>
          <div class="vs-card--content p-0">
             <chartjs-doughnut-chart
                  :height="250"
                  :data="ChartOptions.otherdoughnutchart.data"
                  :options="ChartOptions.otherdoughnutchart.options"
                ></chartjs-doughnut-chart>
             </div>
        </div>
      </vs-col>
      <vs-col vs-lg="6" vs-xs="12">
        <div class="con-vs-card cardx overflow-hidden">
          <header class="vs-card--header">
            <div>
              <h6 class="font-medium">Pie</h6>
            </div>
          </header>
          <div class="vs-card--content p-0">
             <chartjs-pie-chart
                  :height="250"
                  :data="ChartOptions.otherpiechart.data"
                  :options="ChartOptions.otherpiechart.options"
                ></chartjs-pie-chart>
             </div>
        </div>
      </vs-col>
      <vs-col vs-lg="6" vs-xs="12">
        <div class="con-vs-card cardx overflow-hidden">
          <header class="vs-card--header">
            <div>
              <h6 class="font-medium">Polar</h6>
            </div>
          </header>
          <div class="vs-card--content p-0">
             <chartjs-polar-chart
                  :height="250"
                  :data="ChartOptions.otherpolarchart.data"
                  :options="ChartOptions.otherpolarchart.options"
                ></chartjs-polar-chart>
             </div>
        </div>
      </vs-col>
      
       
    </div>
  </div>
</template>
<script>
import ChartjsScatterChart from "../../components/chartjs/ChartjsScatterChart.vue";
import ChartjsDoughnutChart from "../../components/chartjs/ChartjsDoughnutChart.vue";
import ChartjsPieChart from "../../components/chartjs/ChartjsPieChart.vue";
import ChartjsPolarChart from "../../components/chartjs/ChartjsPolarChart.vue";
import ChartJS from "@/demo-data/Chart/Chartjs.js";

export default {
  components: {
   ChartjsScatterChart,
   ChartjsDoughnutChart,
   ChartjsPieChart,
   ChartjsPolarChart
  },
  watch: {
    "$store.state.theme"(val) {
      this.chartTheme(val);
    },
  },
  methods: {
    chartTheme(val) {
      let mode = val == "dark" ? "dark" : "light";
      var keys = Object.keys(this.ChartOptions);

      for (var i = 0; i < keys.length; i++) {
        this.ChartOptions[keys[i]].options = {
          theme: {
            mode: mode,
          },
        };
      }
    },
  },
  mounted() {
    this.chartTheme(this.$store.state.theme);
  },
  data: function () {
    return {
   ChartOptions: ChartJS[0],
    };
  },
};
</script>